<template>
  <div class="transliterate-parent">
  <span class="tool-title">Transliterate from Central Asian Cyrillic
  </span>
    <TransliterationBox :transliterate="transliterateData"/>
  </div>
</template>

<script>
// @ is an alias to /src
import TransliterationBox from "@/components/TransliterationBox.vue";

export default {
  name: "home",
  components: {
    TransliterationBox
  },
  computed: {
    transliterateData() {
      return this.$store.getters.transliterateData;
    }
  }
};
</script>
<style lang="scss" scoped>
.transliterate-parent {
  height: 100%;
}
.tool-title {
  color: #297050;
  font-weight: bold;
}
</style>
